import { render, staticRenderFns } from "./YzRadioSelectionCard.vue?vue&type=template&id=f488d1ce&scoped=true&lang=pug&"
import script from "./YzRadioSelectionCard.vue?vue&type=script&lang=js&"
export * from "./YzRadioSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./YzRadioSelectionCard.vue?vue&type=style&index=0&id=f488d1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488d1ce",
  null
  
)

export default component.exports